<template>
  <div>
    <tool-bar :title="title"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <no-lead-message
      button-text="Dismiss"
      :show="showNoLeadMessage"
      :message="noLeadMessage"
      @onContinue="showNoLeadMessage=false"
    ></no-lead-message>

    <div class="input_container" v-if="isFieldNeededToShow('phone_number')">
      <weex-text class="input_label">{{getFieldLabel('phone_number')}}</weex-text>
      <div class="item-phone-number-input-container margin-top-5">
        <phone-code-item @onPhoneCodeSelected="onPhoneCodeSelected"></phone-code-item>
        <input
          v-bind:class="{
            'item-phone-number-input read-only': phoneNumberInpReadOnly,
            'item-phone-number-input': !phoneNumberInpReadOnly }"
          :value="getFieldValue('phone_number')"
          :readonly="phoneNumberInpReadOnly"
          maxlength="10"
          @input="onInputEntered('phone_number',$event.target.value)"
          type="number"
        />
      </div>
      <field-error-item
          :show-error="showFieldError('phone_number')"
          :error-msg="getErrorMsg('phone_number')"
      ></field-error-item>
    </div>

    <div class="input_container" v-show="isFieldNeededToShow('applicant_type')">
      <weex-text class="input_label">{{ getFieldLabel('applicant_type') }}</weex-text>

      <div class="border-bottom">
        <div
            v-for="applicantTypeOption in applicantTypeOptions" :key="applicantTypeOption.value"
            class="margin-top-10 display-inline-block margin-right-20"
            @click="onInputEntered('applicant_type', applicantTypeOption.value)">
          <div class="item-row-alignment-center">
            <weex-image class="ezcred-radio-image"
                        :src="radioButtonLink(applicantTypeOption)"
            ></weex-image>
            <weex-text class="ezcred-radio-text-font-16">{{ applicantTypeOption.title }}</weex-text>
          </div>
        </div>
      </div>

      <field-error-item
          :show-error="showFieldError('applicant_type')"
          :error-msg="getErrorMsg('applicant_type')"
      ></field-error-item>
    </div>

    <div class="dropdown-container" v-show="isFieldNeededToShow('company_type')">
      <wxc-dropdown
          :title="getFieldLabel('company_type')"
          default-item="Select"
          :config="dropdownConfig"
          :list="companyTypes"
          :hide-additional-details="true"
          @onItemSelected="onInputEntered('company_type',$event.value)"
      ></wxc-dropdown>

      <field-error-item
          :show-error="showFieldError('company_type')"
          :error-msg="getErrorMsg('company_type')"
      ></field-error-item>
    </div>

    <div class="dropdown-container" v-show="isFieldNeededToShow('relation_with_applicant')">
      <wxc-dropdown
          :title="getFieldLabel('relation_with_applicant')"
          default-item="Select"
          :config="dropdownConfig"
          :list="relationTypes"
          :hide-additional-details="true"
          @onItemSelected="onInputEntered('relation_with_applicant',$event.value)"
      ></wxc-dropdown>

      <field-error-item
          :show-error="showFieldError('relation_with_applicant')"
          :error-msg="getErrorMsg('relation_with_applicant')"
      ></field-error-item>
    </div>


    <wxc-button
      text="Continue"
      class="horizontal_center margin-top-30"
      type="blue"
      @wxcButtonClicked="onContinueClicked"
    ></wxc-button>
  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown/index";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import AlertService from "../core/alert/AlertService";
import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
import EzUtils from "../../utils/EzUtils";
import PrefManager from "@/data/model/PrefManager";
import DataSource from "@/data/DataSource";
import NoLeadMessage from "@/components/dialogs/SingleMessageDialog";
import { DefaultResourceConfig, ImageResourcesUtil } from "@/utils/ImageResourcesUtil";
import { Constants } from "../Constants";
import PhoneCodeItem from "@/components/layout/PhoneCodeItem";
import { ValidationPatterns } from "@/utils/ValidationPatterns";
import DynamicFieldUtils, { FieldTypes } from "@/utils/DynamicFieldUtils";
import FieldErrorItem from "@/components/layout/FieldErrorItem";
import DeepClone from "lodash.clonedeep";

const ALL_FIELDS_DATA = {
  phone_number: {
    key: "phone_number",
    label: "Phone Number",
    validation: ValidationPatterns.PHONE_NUMBER_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter valid Phone Number",
    optional: false
  },

  applicant_type: {
    key: "applicant_type",
    label: "Type",
    validation: "",
    fieldType: FieldTypes.RADIO,
    errorMsg: "Please select valid option",
    optional: false,
    hide: true
  },

  company_type: {
    key: "company_type",
    label: "Applying as",
    validation: "",
    fieldType: FieldTypes.DROPDOWN,
    errorMsg: "Please select valid option",
    optional: true,
    hide: true
  },

  relation_with_applicant: {
    key: "relation_with_applicant",
    label: "Relationship with Main Applicant (You are)",
    validation: "",
    fieldType: FieldTypes.DROPDOWN,
    errorMsg: "Please select valid option",
    optional: true,
    hide: true
  }
};

export default {
  name: "CustomerPhoneNumberActivity",
  components: {
    ToolBar,
    WxcButton,
    Loading,
    ErrorAlertItem,
    NoLeadMessage,
    PhoneCodeItem,
    FieldErrorItem,
    WxcDropdown
  },

  data: () => ({
    title: "Customer Phone Number",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showNoLeadMessage: false,
    noLeadMessage: "",
    phoneNumberInpReadOnly: false,
    applicantTypeOptions: [],
    companyTypes: [],
    relationTypes: [],
    fieldsData: {
      phone_number: null,
      applicant_type: null,
      company_type: null,
      relation_with_applicant: null
    },
    invalidFields: [],
    dynamicFields: DeepClone(ALL_FIELDS_DATA),
  }),

  methods: {
    //***methods to use for dynamic fields (start)***
    isFieldNeededToShow(key) {
      return DynamicFieldUtils.isFieldNeededToShow(key, this.dynamicFields);
    },

    isFieldNeeded(key) {
      return DynamicFieldUtils.isFieldNeeded(key, this.dynamicFields);
    },

    getFieldLabel(key) {
      return DynamicFieldUtils.getFieldLabel(key, this.dynamicFields, ALL_FIELDS_DATA);
    },

    getFieldValue(key) {
      return DynamicFieldUtils.getFieldValue(key, this.fieldsData);
    },

    showFieldError(fieldKey) {
      return DynamicFieldUtils.showFieldError(fieldKey, this.invalidFields);
    },

    getErrorMsg(fieldKey) {
      return DynamicFieldUtils.getFieldErrorMsg(fieldKey, ALL_FIELDS_DATA);
    },

    onInputEntered(key, value) {
      this.fieldsData[key] = value;
      this.removeFromInvalidFieldsIfValid(key);
      this.doAdditionalWorkOnInputEntered(key, value);
    },

    doAdditionalWorkOnInputEntered(fieldKey, fieldValue) {
      if (!fieldKey) {
        return;
      }

      if (fieldKey === ALL_FIELDS_DATA.applicant_type.key) {
        const applicantType = fieldValue;
        this.applicantTypeOptions && this.applicantTypeOptions.forEach(option => {
          if (applicantType && applicantType === option.value) {
            option.checked = true;
          } else {
            option.checked = false;
          }
        });

        const retailerConfig = PrefManager.getRetailerConfig();

        //handling company type options
        this.onInputEntered(ALL_FIELDS_DATA.company_type.key, null);
        this.companyTypes = [];
        if (applicantType === Constants.APPLICANT_TYPE_INDIVIDUAL
            && retailerConfig
            && retailerConfig
            && EzUtils.isNotEmpty(retailerConfig.individualCompanyTypes)
        ) {
          const companyTypes = [];
          retailerConfig.individualCompanyTypes.forEach(companyType => {
            companyTypes.push({title: companyType, value:companyType});
          });
          this.companyTypes = companyTypes;
          this.dynamicFields.company_type.hide = false;
          this.dynamicFields.company_type.optional = false;
        } else if (applicantType === Constants.APPLICANT_TYPE_ORGANIZATION
            && retailerConfig
            && EzUtils.isNotEmpty(retailerConfig.organizationCompanyTypes)
        ) {
          const companyTypes = [];
          retailerConfig.organizationCompanyTypes.forEach(companyType => {
            companyTypes.push({title: companyType, value:companyType});
          });
          this.companyTypes = companyTypes;

          this.dynamicFields.company_type.hide = false;
          this.dynamicFields.company_type.optional = false;
        } else {
          this.dynamicFields.company_type.hide = true;
          this.dynamicFields.company_type.optional = true;
        }

        //handling relations options
        this.onInputEntered(ALL_FIELDS_DATA.relation_with_applicant.key, null);
        const associatedEntityConfig = LoanScopeDataHolder.getAssociatedEntityConfig();
        if (EzUtils.isValidId(LoanScopeDataHolder.getParentLoanId())
            && LoanScopeDataHolder.getParentApplicantType()
            && associatedEntityConfig
        ) {
          let applicantTypeToRelationOptions = null;
          const parentApplicantType = LoanScopeDataHolder.getParentApplicantType();

          if(EzUtils.areEqualString(
              parentApplicantType,  Constants.APPLICANT_TYPE_INDIVIDUAL, true
          )) {
            if (EzUtils.areEqualString(applicantType, Constants.APPLICANT_TYPE_INDIVIDUAL, true)) {
              applicantTypeToRelationOptions =
                  associatedEntityConfig["individualToIndividualRelations"];
            } else if (EzUtils.areEqualString(
                applicantType, Constants.APPLICANT_TYPE_ORGANIZATION, true
            )) {
              applicantTypeToRelationOptions =
                  associatedEntityConfig["individualToNonIndividualRelations"];
            }
          } else if (EzUtils.areEqualString(
              parentApplicantType, Constants.APPLICANT_TYPE_ORGANIZATION, true
          )) {
            if (EzUtils.areEqualString(applicantType, Constants.APPLICANT_TYPE_INDIVIDUAL, true)) {
              applicantTypeToRelationOptions =
                  associatedEntityConfig["nonIndividualToIndividualRelations"];
            } else if (EzUtils.areEqualString(
                applicantType, Constants.APPLICANT_TYPE_ORGANIZATION, true
            )) {
              applicantTypeToRelationOptions =
                  associatedEntityConfig["nonIndividualToNonIndividualRelations"];
            }
          }

          if (EzUtils.isNotEmpty(applicantTypeToRelationOptions)) {
            const relationTypes = [];
            applicantTypeToRelationOptions.forEach(relationType => {
              relationTypes.push({title: relationType, value:relationType});
            });
            this.relationTypes = relationTypes;

            this.dynamicFields.relation_with_applicant.hide = false;
            this.dynamicFields.relation_with_applicant.optional = false;
          } else {
            this.dynamicFields.relation_with_applicant.hide = true;
            this.dynamicFields.relation_with_applicant.optional = true;
          }
        }
      }
    },

    removeFromInvalidFieldsIfValid(key) {
      this.invalidFields = DynamicFieldUtils.removeFromInvalidFieldsIfValidValue(
          this.invalidFields,
          key,
          this.fieldsData[key],
          ALL_FIELDS_DATA,
          this.dynamicFields
      );
    },

    checkForValidation() {
      this.invalidFields = DynamicFieldUtils.validateDynamicFieldsForRequiredFields(
          this.fieldsData,
          ALL_FIELDS_DATA,
          this.dynamicFields
      );

      return !this.invalidFields || this.invalidFields.length === 0;
    },
    //***methods to use for dynamic fields (end)***

    radioButtonLink(e) {
      return e.checked
          ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHECKED_RADIO)
          : ImageResourcesUtil.getImageLink(ImageResourcesUtil.UNCHECKED_RADIO);
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onPhoneCodeSelected(phoneCode) {
      LoanScopeDataHolder.setPhoneCode(phoneCode);
    },

    onContinueClicked() {
      if (this.checkForValidation()) {
        LoanScopeDataHolder.setMobile(this.getFieldValue(ALL_FIELDS_DATA.phone_number.key));
        LoanScopeDataHolder.setApplicantType(this.getFieldValue(ALL_FIELDS_DATA.applicant_type.key));
        LoanScopeDataHolder.setCompanyType(this.getFieldValue(ALL_FIELDS_DATA.company_type.key));
        LoanScopeDataHolder.setRelationWithApplicant(this.getFieldValue(ALL_FIELDS_DATA.relation_with_applicant.key));
        const retailerConfig = PrefManager.getRetailerConfig();
        this.loading = true;
         DataSource.getLeadDetails(
            null,
             this.getFieldValue(ALL_FIELDS_DATA.phone_number.key),
            null,
            null,
            PrefManager.getUserOfficeId()
        )
        .then(leadDetailsRes => {
          this.loading = false;
          if (leadDetailsRes.errorOccurred) {
            this.showError(leadDetailsRes.data);
          } else {
            const leadDetails = leadDetailsRes.data;
            if (!leadDetails && retailerConfig && retailerConfig.enforceLeadForLoanCreation) {
              this.noLeadMessage = `No existing lead found for ${this.getFieldValue(
                  ALL_FIELDS_DATA.phone_number.key)}. Please contact support.`;
              this.showNoLeadMessage = true;
            } else {
              let nextActivity = EzUtils.isValidId(LoanScopeDataHolder.getParentLoanId())
                  ? Activities.CLIENT_DETAILS
                  : Activities.LOAN_PRODUCT_DETAILS;
              if (leadDetails) {
                const retailerName = leadDetails.partner_name;
                if (retailerName && retailerName.toString().toLowerCase().includes("airtel")) {
                  const leadDetailsData = leadDetails.data
                      ? EzUtils.convertToJSONObjectIfString(leadDetails.data)
                      : {};

                  const loanAmount = EzUtils.isAValidNumber(leadDetailsData.loanAmount)
                      ? Number(leadDetailsData.loanAmount).toFixed(0).toString()
                      : (EzUtils.isAValidNumber(leadDetailsData.productPrice)
                              ? Number(leadDetailsData.productPrice).toFixed(0).toString()
                              : 0
                      );

                  const category = leadDetails.category;
                  const brand = leadDetails.brand;
                  const model = leadDetails.model;

                  if (loanAmount > 0 && category && brand && model) {
                    nextActivity = Activities.CLIENT_DETAILS;
                    LoanScopeDataHolder.setProductCategory(category);
                    LoanScopeDataHolder.setBrand(brand);
                    LoanScopeDataHolder.setModel(model);
                    LoanScopeDataHolder.setLoanAmount(loanAmount);
                  }
                }
              }
              LoanScopeDataHolder.setLeadDetails(leadDetails);
              this.startNextActivity(nextActivity);
            }
          }
        });
      }
    },

    startNextActivity(activity) {
      ActivityNavigator.navigateTo(activity);
    }
  },

  created() {
    if (EzUtils.validatePhoneNumber(LoanScopeDataHolder.getMobile())) {
      this.onInputEntered(ALL_FIELDS_DATA.phone_number.key, LoanScopeDataHolder.getMobile());
      this.phoneNumberInpReadOnly = true;
    }
    const retailerConfig = PrefManager.getRetailerConfig();
    if (retailerConfig) {
      const applicantTypes = retailerConfig["applicantTypes"];
      if (applicantTypes && applicantTypes.length > 0) {
        if (applicantTypes.length === 1) {
          this.applicantTypeOptions.push({
            checked: true,
            title: EzUtils.convertToUpperCamelCase(applicantTypes[0]),
            value: applicantTypes[0]
          });
          this.onInputEntered(ALL_FIELDS_DATA.applicant_type.key, applicantTypes[0]);
        } else {
          applicantTypes.forEach(applicantType => {
            if (applicantType) {
              const name = EzUtils.convertToUpperCamelCase(applicantType);
              const option = { checked: false, title: name, value: applicantType };
              this.applicantTypeOptions.push(option);
            }
          });
          this.dynamicFields.applicant_type.hide = false;
        }
      } else {
        this.applicantTypeOptions.push({
          checked: true,
          title: EzUtils.convertToUpperCamelCase(Constants.APPLICANT_TYPE_INDIVIDUAL),
          value: Constants.APPLICANT_TYPE_INDIVIDUAL
        });
        this.onInputEntered(ALL_FIELDS_DATA.applicant_type.key, Constants.APPLICANT_TYPE_INDIVIDUAL);
      }
    } else {
      this.applicantTypeOptions.push({
        checked: true,
        title: EzUtils.convertToUpperCamelCase(Constants.APPLICANT_TYPE_INDIVIDUAL),
        value: Constants.APPLICANT_TYPE_INDIVIDUAL
      });
      this.onInputEntered(ALL_FIELDS_DATA.applicant_type.key, Constants.APPLICANT_TYPE_INDIVIDUAL);
    }
  },

  computed: {
    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

